import React from "react";
import { Box } from "@mui/system";

function MainBox({ children }) {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          position: "fixed",
          height: "100%",
          width: "100%",
        }}>
        {children}
      </Box>
    </>
  );
}

export default MainBox;
